import apiClient from '../utils/apiClient';

const API_URL = '/api/users';

const userService = {
  // Get current user profile
  getProfile: async () => {
    const response = await apiClient.get(`${API_URL}/profile`);
    return response.data.user;
  },
  
  // Update user profile
  updateProfile: async (profileData) => {
    const response = await apiClient.put(`${API_URL}/profile`, profileData);
    return response.data;
  },
  
  // Get user by username
  getUserByUsername: async (username) => {
    const response = await apiClient.get(`${API_URL}/by-username/${username}`);
    return response.data.user;
  },
  
  // Get public profile for a user
  getPublicProfile: async (userId) => {
    const response = await apiClient.get(`${API_URL}/${userId}/public`);
    return response.data;
  },
  
  // Toggle public profile setting
  togglePublicProfile: async () => {
    const response = await apiClient.post(`${API_URL}/settings/toggle-public`, {});
    return response.data;
  },
  
  // Toggle newsletter subscription
  toggleNewsletter: async () => {
    const response = await apiClient.post(`${API_URL}/settings/toggle-newsletter`, {});
    return response.data;
  },
  
  // Change password
  changePassword: async (passwordData) => {
    const response = await apiClient.post(`${API_URL}/change-password`, passwordData);
    return response.data;
  },
  
  // Guest newsletter signup - unauthenticated endpoint
  guestNewsletterSignup: async (email) => {
    const response = await apiClient.post(`${API_URL}/guest-newsletter-signup`, { email });
    return response.data;
  },

  // Upload avatar
  uploadAvatar: async (file) => {
    const formData = new FormData();
    formData.append('avatar', file);
    
    const response = await apiClient.post(`${API_URL}/avatar`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Remove avatar
  removeAvatar: async () => {
    const response = await apiClient.delete(`${API_URL}/avatar`);
    return response.data;
  }
};

export default userService;